export default "__VITE_ASSET__f45dd617__"